export default __webpack_public_path__ + "images/e170c378e267082191b16022ff7b7246-stress-reduction.svg";